module.exports = __webpack_public_path__ + "media/images/categories/duplex-7f42b2e7a232bc72e6fa6fadcf31545d.png";